import API from "../../utils/endpoints";
import history from "../../history";
import * as types from "./actionType";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchSingleRideMembership } from "../rides/actions";
import config from "../../utils/config";
import axios from "axios";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function searchingFilterForUser() {
  return {
    type: types.SEARCH_FILTER_FOR_USER,
  };
}

function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

function fetchingAllUser() {
  return {
    type: types.FETCH_ALL_USERS,
  };
}

function fetchingAllUserSuccess(payload) {
  return {
    type: types.FETCH_ALL_USERS_SUCCESS,
    payload,
  };
}

function fetchingAllUserFailed() {
  return {
    type: types.FETCH_ALL_USERS_FAILED,
  };
}

function fetchingSingleUser() {
  return {
    type: types.FETCH_SINGLE_USER,
  };
}

function fetchingSingleUserSuccess(payload) {
  return {
    type: types.FETCH_SINGLE_USER_SUCCESS,
    payload,
  };
}

function fetchingSingleUserFailed() {
  return {
    type: types.FETCH_SINGLE_USER_FAILED,
  };
}

function userOnBoarding() {
  return {
    type: types.USER_ON_BOARDING,
  };
}

function userOnBoardingSuccess(payload) {
  return {
    type: types.USER_ON_BOARDING_SUCCESS,
    payload,
  };
}

function userOnBoardingFailed() {
  return {
    type: types.USER_ON_BOARDING_FAILED,
  };
}

function creatingUser() {
  return {
    type: types.CREATE_USER,
  };
}

function creatingUserSuccess(payload) {
  return {
    type: types.CREATE_USER_SUCCESS,
    payload,
  };
}

function creatingUserFailed() {
  return {
    type: types.CREATE_USER_FAILED,
  };
}

function registeringConsentForm() {
  return {
    type: types.REGISTER_CONSENT_FORM,
  };
}

function registeringConsentFormSuccess(payload) {
  return {
    type: types.REGISTER_CONSENT_FORM_SUCCESS,
    payload,
  };
}

function registeringConsentFormFailed() {
  return {
    type: types.REGISTER_CONSENT_FORM_FAILED,
  };
}

function fetchingUserCountryMobileCode() {
  return {
    type: types.FETCH_USER_COUNTRY_MOBILE_CODE,
  };
}

function fetchingUserCountryMobileCodeSuccess(payload) {
  return {
    type: types.FETCH_USER_COUNTRY_MOBILE_CODE_SUCCESS,
    payload,
  };
}

function fetchingUserCountryMobileCodeFailed() {
  return {
    type: types.FETCH_USER_COUNTRY_MOBILE_CODE_FAILED,
  };
}

function fetchingUserCountryJsonMobileCode() {
  return {
    type: types.FETCH_USER_COUNTRY_JSON_MOBILE_CODE,
  };
}

function fetchingUserCountryJsonMobileCodeSuccess(payload) {
  return {
    type: types.FETCH_USER_COUNTRY_JSON_MOBILE_CODE_SUCCESS,
    payload,
  };
}

function fetchingUserCountryJsonMobileCodeFailed() {
  return {
    type: types.FETCH_USER_COUNTRY_JSON_MOBILE_CODE_FAILED,
  };
}

function fetchingMotorCycle() {
  return {
    type: types.FETCH_MOTORCYCLE,
  };
}

function fetchingMotorCycleSuccess(payload) {
  return {
    type: types.FETCH_MOTORCYCLE_SUCCESS,
    payload,
  };
}

function fetchingMotorCycleFailed() {
  return {
    type: types.FETCH_MOTORCYCLE_FAILED,
  };
}

function fetchingUserCountry() {
  return {
    type: types.FETCH_USER_COUNTRY,
  };
}

function fetchingUserCountrySuccess(payload) {
  return {
    type: types.FETCH_USER_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingUserCountryFailed() {
  return {
    type: types.FETCH_USER_COUNTRY_FAILED,
  };
}

function fetchingMotorCycleCountry() {
  return {
    type: types.FETCH_MOTOR_CYCLE_COUNTRY,
  };
}

function fetchingMotorCycleCountrySuccess(payload) {
  return {
    type: types.FETCH_MOTOR_CYCLE_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingMotorCycleCountryFailed() {
  return {
    type: types.FETCH_MOTOR_CYCLE_COUNTRY_FAILED,
  };
}

function vechicleOnBoarding() {
  return {
    type: types.VECHICLE_ONBOARDING,
  };
}

function vechicleOnBoardingSuccess(payload) {
  return {
    type: types.VECHICLE_ONBOARDING_SUCCESS,
    payload,
  };
}

function vechicleOnBoardingFailed() {
  return {
    type: types.VECHICLE_ONBOARDING_FAILED,
  };
}

function pendingVechicleOnBoarding() {
  return {
    type: types.PENDING_VECHICLE_ONBOARDING,
  };
}

function pendingVechicleOnBoardingSuccess(payload) {
  return {
    type: types.PENDING_VECHICLE_ONBOARDING_SUCCESS,
    payload,
  };
}

function pendingVechicleOnBoardingFailed() {
  return {
    type: types.PENDING_VECHICLE_ONBOARDING_FAILED,
  };
}

function vechicleDetailing() {
  return {
    type: types.VECHICLE_DETAILS,
  };
}

function vechicleDetailingSuccess(payload) {
  return {
    type: types.VECHICLE_DETAILS_SUCCESS,
    payload,
  };
}

function vechicleDetailingFailed() {
  return {
    type: types.VECHICLE_DETAILS_FAILED,
  };
}

function ridersRegistering() {
  return {
    type: types.RIDERS_REGISTER,
  };
}

function ridersRegisteringSuccess(payload) {
  return {
    type: types.RIDERS_REGISTER_SUCCESS,
    payload,
  };
}

function ridersRegisteringFailed() {
  return {
    type: types.RIDERS_REGISTER_FAILED,
  };
}

function fetchingOnBoardedUsers() {
  return {
    type: types.FETCH_ONBOARD_USERS,
  };
}

function fetchingOnBoardedUsersSuccess(payload, count) {
  return {
    type: types.FETCH_ONBOARD_USERS_SUCCESS,
    payload,
    count,
  };
}

function fetchingOnBoardedUsersFailed() {
  return {
    type: types.FETCH_ONBOARD_USERS_FAILED,
  };
}

function fetchingOnBoardedUsersDetail() {
  return {
    type: types.ONBOARD_USERS_DETAIL,
  };
}

function fetchingOnBoardedUsersDetailSuccess(payload) {
  return {
    type: types.ONBOARD_USERS_DETAIL_SUCCESS,
    payload,
  };
}

function fetchingOnBoardedUsersDetailFailed() {
  return {
    type: types.ONBOARD_USERS_DETAIL_FAILED,
  };
}

function fetchingPreRegisterUser() {
  return {
    type: types.FETCH_PRE_REGISTER_USER,
  };
}

function fetchingPreRegisterUserSuccess(payload, count) {
  return {
    type: types.FETCH_PRE_REGISTER_USER_SUCCESS,
    payload,
    count,
  };
}

function fetchingPreRegisterUserFailed() {
  return {
    type: types.FETCH_PRE_REGISTER_USER_FAILED,
  };
}

function exportingToExcel() {
  return {
    type: types.EXPORT_TO_EXCEL,
  };
}

function exportingToExcelSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_SUCCESS,
    payload,
  };
}

function exportingToExcelFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_FAILED,
  };
}

function fetchingUserVehicles() {
  return {
    type: types.FETCH_USER_VEHICLES,
  };
}

function fetchingUserVehiclesSuccess(payload) {
  return {
    type: types.FETCH_USER_VEHICLES_SUCCESS,
    payload,
  };
}

function fetchingUserVehiclesFailed() {
  return {
    type: types.FETCH_USER_VEHICLES_FAILED,
  };
}

function vechicleOnBoardingFromMemberShip() {
  return {
    type: types.VECHICLE_ONBOARDING_FROM_MEMBERSHIP,
  };
}

function vechicleOnBoardingFromMemberShipSuccess(payload) {
  return {
    type: types.VECHICLE_ONBOARDING_FROM_MEMBERSHIP_SUCCESS,
    payload,
  };
}

function vechicleOnBoardingFromMemberShipFailed() {
  return {
    type: types.VECHICLE_ONBOARDING_FROM_MEMBERSHIP_FAILED,
  };
}

function fetchingAllDealer() {
  return {
    type: types.FETCH_ALL_DEALER,
  };
}

function fetchingAllDealerSuccess(payload, count) {
  return {
    type: types.FETCH_ALL_DEALER_SUCCESS,
    payload,
    count,
  };
}

function fetchingAllDealerFailed() {
  return {
    type: types.FETCH_ALL_DEALER_FAILED,
  };
}

function fetchingCountry() {
  return {
    type: types.FETCH_COUNTRY,
  };
}

function fetchingCountrySuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingCountryFailed() {
  return {
    type: types.FETCH_COUNTRY_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

function fetchingCity() {
  return {
    type: types.FETCH_CITY,
  };
}

function fetchingCitySuccess(payload) {
  return {
    type: types.FETCH_CITY_SUCCESS,
    payload,
  };
}

function fetchingCityFailed() {
  return {
    type: types.FETCH_CITY_FAILED,
  };
}

//****** searchFilterForUser  ********//

export const searchFilterForUser = (payload) => async (dispatch) => {
  dispatch(searchingFilterForUser());
};

//****** clearPreviousReducer  ********//

export const clearPreviousReducer = (payload) => async (dispatch) => {
  dispatch(clearingPreviousReducer());
};

//****** Fetching User  ********//

export const fetchAllUser = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllUser());
  try {
    let response = await api.get(
      `${API.fetchAllUser}?page=${payload.page}&phone=${payload.phone}&email=${payload.email}&limit=${payload.limit}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingAllUserSuccess(response.data.data));
    } else {
      dispatch(fetchingAllUserFailed());
    }
  } catch (error) {
    dispatch(fetchingAllUserFailed(errorMessage));
  }
};

//****** user On Board  ********//

export const userOnBoard = (payload) => async (dispatch, getState, api) => {
  dispatch(userOnBoarding());
  try {
    let response = await api.get(API.fetcuserOnBoardhCountry);
    if (response.data.code === 200) {
      dispatch(userOnBoardingSuccess(response.data.data));
    } else {
      dispatch(userOnBoardingFailed());
    }
  } catch (error) {
    dispatch(userOnBoardingFailed(errorMessage));
  }
};

//****** create User  ********//

export const createUser = (payload) => async (dispatch, getState, api) => {
  dispatch(creatingUser());
  try {
    let response = await api.post(API.createUser, payload.dataForRegister);

    if (response.data.code === 200) {
      dispatch(creatingUserSuccess(response.data.data));
      dispatch(registerUserConsentForm(payload, response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(creatingUserFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingUserFailed(errorMessage));
  }
};

//****** Consent Form  ********//

export const registerUserConsentForm = (payload, data) => async (
  dispatch,
  getState,
  api
) => {
  let finalData = {
    guid: data.guid,
    userId: data._id,
    cluster: data.cluster,
    terms_and_conditions: payload.terms_and_conditions,
    promotionsnews: payload.dataForConsents.promotionsnews,
    surveysandresearch: payload.dataForConsents.surveysandresearch,
    communityactivities: payload.dataForConsents.communityactivities,
    allpromotions: payload.dataForConsents.allpromotions,
    donotphone: payload.dataForConsents.donotphone,
    donotemail: payload.dataForConsents.donotemail,
  };
  dispatch(registeringConsentForm());
  try {
    let response = await api.post(API.registerUserConsentForm, finalData);

    if (response.data.code === 200) {
      dispatch(registeringConsentFormSuccess(response.data.data));
      // history.push(`/user/vechile-onboarding?guid=${data.guid}&id=${data._id}`);
      history.push(
        `/user/detail?cluster=${data.cluster}&guid=${data.guid}&userId=${data._id}`
      );
      toast.error(response.data.message);
    } else {
      dispatch(registeringConsentFormFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(registeringConsentFormFailed(errorMessage));
  }
};

//****** fetchingSingleUser  ********//

export const fetchSingleUser = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingSingleUser());
  try {
    let response = await api.get(
      `${API.fetchSingleUser}?cluster=${payload.cluster}&guid=${payload.guid}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingSingleUserSuccess(response.data.data));
    } else {
      dispatch(fetchingSingleUserFailed());
    }
  } catch (error) {
    dispatch(fetchingSingleUserFailed(errorMessage));
  }
};

//****** fetchingSingleUser  ********//

export const fetchUserCountryMobileCode = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingUserCountryMobileCode());
  try {
    let response = await api.get(API.fetchUserCountryMobileCode);
    if (response.data.code === 200) {
      dispatch(fetchingUserCountryMobileCodeSuccess(response.data.data));
    } else {
      dispatch(fetchingUserCountryMobileCodeFailed());
    }
  } catch (error) {
    dispatch(fetchingUserCountryMobileCodeFailed(errorMessage));
  }
};

//***** CountryJson */
export const fetchUserCountryJSON = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingUserCountryJsonMobileCode());
  // try {
  //   let response = await api.get(
  //     `${config.countryJsonUrl}/node/assets/master-data/locations-master/countries.json`
  //   );
  //   {
  //     console.log("respo", response);
  //   }
  //   if (response.status === 200) {
  //     dispatch(fetchingUserCountryJsonMobileCodeSuccess(response.data));
  //   } else {
  //     dispatch(fetchingUserCountryJsonMobileCodeFailed());
  //   }
  // } catch (error) {
  //   dispatch(fetchingUserCountryJsonMobileCodeFailed(errorMessage));
  // }

  axios
    .get(
      `${config.countryJsonUrl}/node/assets/master-data/locations-master/countries.json`
    )
    .then((response) => {
      if (response.status === 200) {
      dispatch(fetchingUserCountryJsonMobileCodeSuccess(response.data));
      } else {
       dispatch(fetchingUserCountryJsonMobileCodeFailed());
      }
    })
    .catch((error) => {});
};
//****** fetchMotorCylce  ********//

export const fetchMotorCylce = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingMotorCycle());
  try {
    let response = await api.get(`${API.fetchMotorCylce}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingMotorCycleSuccess(response.data.data));
    } else {
      dispatch(fetchingMotorCycleFailed());
    }
  } catch (error) {
    dispatch(fetchingMotorCycleFailed(errorMessage));
  }
};

//****** fetchUserCountry  ********//

export const fetchUserCountry = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingUserCountry());
  try {
    let response = await api.get(API.fetchCountryBranch);

    if (response.data.code === 200) {
      dispatch(fetchingUserCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingUserCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingUserCountryFailed(errorMessage));
  }
};

//****** Fetch MotorCycleCountry   ********//

export const fetchMotorCycleCountry = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingMotorCycleCountry());
  try {
    let response = await api.get(API.fetchMotorCycleCountry);

    if (response.data.code === 200) {
      dispatch(fetchingMotorCycleCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingMotorCycleCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingMotorCycleCountryFailed(errorMessage));
  }
};

//****** vechicle Onboarding  ********//

export const vechicleOnBoard = (payload) => async (dispatch, getState, api) => {
  dispatch(vechicleOnBoarding());
  try {
    let response = await api.post(API.vechicleOnBoard, payload);
    console.log("Checking payload", payload);
    let member = sessionStorage.getItem("member");
    if (response.data.code === 200) {
      dispatch(vechicleOnBoardingSuccess(response.data.data));

      // if (member === "TRUE") {
      //   history.push(`/user/riders-registration?vehicleId=${response.data.data}`);
      // } else {
      //   history.push("/user/list");
      // }
      history.push(
        `/user/detail?cluster=${payload.cluster}&guid=${payload.userGUID}&userId=${payload.userID}`
      );
      // if (response.data.data.vinDuplicate === true) {
      //   toast.error("Duplicate Vin");
      // }
      toast.error(response.data.message);
    } else {
      dispatch(vechicleOnBoardingFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(vechicleOnBoardingFailed(errorMessage));
  }
};

//****** vechicle Onboarding  ********//

export const vechicleOnBoardFromMemberShip = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(vechicleOnBoardingFromMemberShip());
  try {
    let response = await api.post(API.vechicleOnBoard, payload);

    if (response.data.code === 200) {
      dispatch(vechicleOnBoardingFromMemberShipSuccess(response.data.data));
      // if (response.data.data.vinDuplicate === true) {
      //   toast.error("Duplicate Vin");
      // }
      dispatch(fetchUserVehicles(payload.userID));
      toast.error(response.data.message);
    } else {
      dispatch(vechicleOnBoardingFromMemberShipFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(vechicleOnBoardingFromMemberShipFailed(errorMessage));
  }
};

//**Pending vehicle onBoarding */

export const pendingVehicleOnBoard = (payload, vehicleId) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(pendingVechicleOnBoarding());

  try {
    let response = await api.post(API.pendingVechicleOnBoard, payload);
    if (response.data.code === 200) {
      dispatch(pendingVechicleOnBoardingSuccess(response.data.data));
      history.push(
        `/rides/member-detail?guid=${payload.userGUID}&id=${payload.userID}&vehicleId=${vehicleId}`
      );
      dispatch(fetchSingleRideMembership(payload.userGUID));
      toast.error(response.data.message);
      // if (response.data.data.vinDuplicate === true) {
      //   toast.error("Duplicate Vin");
      // }
    } else {
      dispatch(pendingVechicleOnBoardingFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(pendingVechicleOnBoardingFailed(errorMessage));
  }
};

//****** vechicle Onboarding  ********//

export const vechicleDetail = (payload) => async (dispatch, getState, api) => {
  dispatch(vechicleDetailing());
  try {
    let response = await api.get(`${API.vechicleDetail}?vehicleId=${payload}`);

    if (response.data.code === 200) {
      dispatch(vechicleDetailingSuccess(response.data.data));
      history.push(`/user/riders-registration?vehicleId=${payload}`);
    } else {
      dispatch(vechicleDetailingFailed());
    }
  } catch (error) {
    dispatch(vechicleDetailingFailed(errorMessage));
  }
};

//****** ridersRegister  ********//

export const ridersRegister = (payload) => async (dispatch, getState, api) => {
  dispatch(ridersRegistering());
  try {
    let response = await api.post(API.ridersRegister, payload);

    if (response.data.code === 200) {
      dispatch(ridersRegisteringSuccess(response.data.data));
      history.push(`/user/list`);
      toast.error(response.data.message);
    } else if (response.data.code === 409) {
      dispatch(ridersRegisteringFailed());
      history.push(`/user/list`);
      toast.error(response.data.message);
    } else {
      dispatch(ridersRegisteringFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(ridersRegisteringFailed(errorMessage));
  }
};

//****** On Boarded User List  ********//

export const fetchOnBoardedUsers = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingOnBoardedUsers());
  try {
    console.log({ payload });
    let response = await api.get(
      `${API.fetchOnBoardedUsers}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}&email=${payload.email}&name=${payload.firstName}&clubMember=${payload.clubMember}&dealerId=${payload.dealerId}&countryCode=${payload.countryCode}&state=${payload.state}&city=${payload.city}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingOnBoardedUsersSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingOnBoardedUsersFailed());
    }
  } catch (error) {
    dispatch(fetchingOnBoardedUsersFailed(errorMessage));
  }
};

//******  On Boarded User Detail ********//

export const fetchOnBoardedUsersDetail = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingOnBoardedUsersDetail());
  try {
    let response = await api.get(`${API.fetchSingleUser}?userId=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingOnBoardedUsersDetailSuccess(response.data.data));
    } else {
      dispatch(fetchingOnBoardedUsersDetailFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingOnBoardedUsersDetailFailed(errorMessage));
  }
};

//******  FETCH_PRE_REGISTER_USER ********//

export const fetchPreRegisteredUser = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingPreRegisterUser());
  try {
    let response = await api.get(
      `${API.fetchPreRegisteredUser}?page=${payload.page}&limit=${payload.count}&startDate=${payload.startDate}&endDate=${payload.endDate}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingPreRegisterUserSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingPreRegisterUserFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingPreRegisterUserFailed(errorMessage));
  }
};

//******  EXPORT_TO_EXCEL ********//

export const exportToExcel = (payload) => async (dispatch, getState, api) => {
  dispatch(exportingToExcel());
  try {
    let response = await api.post(
      payload.key === "onboardUser"
        ? API.exportToExcelOnBoard
        : API.exportToExcelPreReg,
      payload
    );

    if (response.data.code === 200) {
      dispatch(exportingToExcelSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelFailed(errorMessage));
  }
};

export const fetchUserVehicles = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingUserVehicles());
  try {
    let response = await api.get(`${API.fetchUserVehicles}?userId=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingUserVehiclesSuccess(response.data.data));
    } else {
      dispatch(fetchingUserVehiclesFailed());
    }
  } catch (error) {
    dispatch(fetchingUserVehiclesFailed(errorMessage));
  }
};

export const fetchAllDealer = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllDealer());
  try {
    let response = await api.get(
      `${API.fetchAllDealer}?page=${payload.page}&country=${payload.country}&state=${payload.state}&city=${payload.city}&emailId=${payload.emailId}&phone=${payload.phone}&dealerId=${payload.dealerId}&limit=${payload.limit}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingAllDealerSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingAllDealerFailed());
    }
  } catch (error) {
    dispatch(fetchingAllDealerFailed(errorMessage));
  }
};

//****** Fetching Country  ********//

export const fetchCountry = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCountry());
  try {
    let response = await api.get(API.fetchCountry);
    if (response.data.code === 200) {
      dispatch(fetchingCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryFailed(errorMessage));
  }
};

//****** Fetching State  ********//

export const fetchState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(`${API.fetchDealerState}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
  }
};

//****** Fetching City  ********//

export const fetchCity = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCity());
  try {
    let response = await api.get(
      `${API.fetchDealerCity}?country=${payload.countryCode}&stateName=${payload.state} `
    );

    if (response.data.code === 200) {
      dispatch(fetchingCitySuccess(response.data.data));
    } else {
      dispatch(fetchingCityFailed());
    }
  } catch (error) {
    dispatch(fetchingCityFailed(errorMessage));
  }
};
